<template>
  <div v-if="showNowThisGrid">
    <div id="to-ruler"></div>
    <div id="to-nowthis-grid">
      <div id="to-action-safe" class="wt-to-snap"></div>
      <div id="to-title-safe" class="wt-to-snap"></div>
      <div id="to-middle-cross"></div>
    </div>
  </div>
</template>

<script>
/**
 * Asset Editor's text overlay now this grid Vue
 */
export default {
  computed: {
    showNowThisGrid: function () {
      return !!this.$store.state.assetEditor.pageTmpState.showNowThisGrid;
    },
  },
};
</script>
